import Link from "next/link";
import { Button } from "@/components/ui/button";
import PremiumWelcomeSummary from "./PremiumWelcomeSummary";

export type PremiumWelcomePageState = "loading" | "ready" | "redirecting";

type PremiumWelcomePageContentProps = {
  state: PremiumWelcomePageState;
  tier: number;
  loadingLabel: string;
  redirectingLabel: string;
  playLabel: string;
  playHref?: string;
};

export default function PremiumWelcomePageContent({
  state,
  tier,
  loadingLabel,
  redirectingLabel,
  playLabel,
  playHref,
}: PremiumWelcomePageContentProps) {
  if (state === "loading") {
    return <div className="py-12 text-sm text-altgray-600">{loadingLabel}</div>;
  }

  if (state === "redirecting") {
    return (
      <div className="py-12 text-sm text-altgray-600">{redirectingLabel}</div>
    );
  }

  return (
    <>
      <PremiumWelcomeSummary tier={tier} />
      <div className="w-full max-w-[420px] mt-6 text-center">
        {playHref ? (
          <Link href={playHref}>
            <Button
              variant="default"
              size="wide"
              className="mx-auto w-full sm:w-auto"
            >
              {playLabel}
            </Button>
          </Link>
        ) : (
          <Button
            variant="default"
            size="wide"
            className="mx-auto w-full sm:w-auto"
          >
            {playLabel}
          </Button>
        )}
      </div>
    </>
  );
}
